import React from 'react'

export interface ToggleSwitchInterface {
  initialState: boolean
  onChangeCallback: (event: React.ChangeEvent<HTMLInputElement>) => void
  isDisabled?: boolean
  id: string
  onColor?: string
  offColor?: string
}

function ToggleSwitch({
  id,
  initialState,
  onChangeCallback,
  isDisabled = false,
  onColor = 'bg-lime-500',
  offColor = 'bg-[#E9E9EA]',
}: ToggleSwitchInterface) {
  const [backgroundColor, setBackgroundColor] = React.useState(offColor)
  const [sliderPosition, setSliderPosition] = React.useState('left-1')

  React.useEffect(() => {
    setSliderPosition(initialState ? 'left-5' : 'left-1')
    setBackgroundColor(initialState ? onColor : offColor)
  }, [initialState])

  return (
    <label
      htmlFor={id}
      className={`relative ${backgroundColor} h-6 w-10 cursor-pointer rounded-full`}
      aria-label={`toggle switch control ${id}`}
    >
      <input
        id={id}
        disabled={isDisabled}
        type="checkbox"
        checked={initialState}
        className="sr-only"
        onChange={onChangeCallback}
      />
      <span
        className={`absolute h-4 w-4 rounded-full bg-white ${sliderPosition} top-1 transition-all duration-300`}
      ></span>
    </label>
  )
}

export default ToggleSwitch
